export const PERMISSIONS = {
    ALL_ACCESS: 'ALL_ACCESS',

    EMPLOYEE_VIEW: 'EMPLOYEE_VIEW',
    EMPLOYEE_EDIT: 'EMPLOYEE_EDIT',

    USER_ACCESS_EDIT: 'USER_ACCESS_EDIT',

    PAYROLL_VIEW: 'PAYROLL_VIEW',
    PAYROLL_EDIT: 'PAYROLL_EDIT',
    PAYROLL_RUN: 'PAYROLL_RUN',
    PAYROLL_EXPORT: 'PAYROLL_EXPORT',

    LEAVE_APPROVE: 'LEAVE_APPROVE',
    LEAVE_CREATE: 'LEAVE_CREATE',

    JOB_VIEW: 'JOB_VIEW',
    JOB_EDIT: 'JOB_EDIT',

    ROSTER_EDIT: 'ROSTER_EDIT',

    PROFILE_VIEW: 'PROFILE_VIEW',

    TIMESHEET_SUBMIT: 'TIMESHEET_SUBMIT',
};